import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as echarts from 'echarts'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { get, post, GET, fetchGet1 } from './request/http'
import * as Http from './request/http'
import axios from 'axios'
import md5 from "js-md5"
import VueLazyload from 'vue-lazyload'
import echartsMap from './plugins/echarts'
import './assets/css/common.css'
Vue.use(echartsMap)
import htmlToPdf from '@/plugins/htmlToPdf'
// 使用Vue.use()方法就会调用工具方法中的install方法
Vue.use(htmlToPdf)

import qs from 'qs'
import Blob from './Excel/Blob'
import Export2Excel from './Excel/Export2Excel.js'

Vue.prototype.axios = axios
Vue.prototype.Http = Http
Vue.prototype.$md5 = md5
Vue.config.productionTip = false
Vue.prototype.echarts = echarts
Vue.prototype.qs = qs
Vue.prototype.$get = get
Vue.prototype.$GET = GET
Vue.prototype.$post = post
Vue.prototype.$fetchGet1 = fetchGet1


// Vue.prototype.$url = 'http://172.16.2.242:8081/'  //钦松本地
// Vue.prototype.$url = 'http://123.60.72.41:8085/'  //  测试外网
// Vue.prototype.$url = 'http://172.16.9.72:8086/'  //测试内网
Vue.prototype.$url = 'http://leshanfx.tiance.cn/api/'  //正式

// Vue.prototype.$url = 'http://pv8rc6.natappfree.cc/'

// Vue.prototype.$POST = POST
Vue.use(ElementUI);
Vue.use(VueLazyload)


// 检查token
router.beforeEach((to, from, next) => {
    let token = localStorage.getItem('token') || '';
    if (to.meta.requireAuth) {  // 定义路由时 添加一个自定义字段requireAuth,用于判断路由的访问是否需要登录（见下方路由字典）
        if (token) {
            // store.commit('getUser'); // 调用获取userInfo的方法
            // this.$router.push('/')

            next()
        } else {
            //   store.commit('logout'); // 调用退出登录的方法
            next({
                path: '/login',
                query: { redirect: to.fullPath }
            })
        }
    } else {
        next()
    }
})
// 过滤器
Vue.filter("permissionFilter", function (value) {
    switch (value) {
        case '03':
            return '市中区';
            break;
        case '04':
            return '沙湾区';
            break;
        case '05':
            return '五通桥区';
            break;
        case '06':
            return '金口河区';
            break;
        case '07':
            return '犍为县';
            break;
        case '08':
            return '井研县';
            break;
        case '09':
            return '夹江县';
            break;
        case '10':
            return '沐川县';
            break;
        case '11':
            return '峨边彝族自治县';
            break;
        case '12':
            return '马边彝族自治县';
            break;
        case '13':
            return '峨眉山市';
            break;
        case '16':
            return '企业查询权限';
            break;
        case '18':
            return '专利查询权限';
            break;
        case '19':
            return '专利分析权限';
            break;
        case '20':
            return '商标查询权限';
            break;
        case '21':
            return '商标分析权限';
            break;

        case '25':
            return '地标产品管理权限';
            break;
        case '26':
            return '地标商标管理权限';
            break;
        case '27':
            return '用户管理权限';
            break;
        case '30':
            return '报告管理权限';
            break;
        case '31':
            return '服务资询权限';
            break;
        default:
            return ''
    }
})
Vue.filter("applyerType", function (value) {
    switch (value) {
        case '1':
            return '工矿企业';
            break;
        case '2':
            return '科研单位';
            break;
        case '3':
            return '大专院校';
            break;
        case '4':
            return '机关团体';
            break;
        case '5':
            return '个人';
            break;
    }
})
Vue.filter("patentType", function (value) {
    switch (value) {
        case 1:
            return "发明";
            break;
        case 2:
            return "实用新型";
            break;
        case 3:
            return "外观设计";
            break;

        case 8:
            return "PCT发明"
            break;
        case 9:
            return "PCT实用新型";
            break;
    }
})

// 设置全局过滤千分位
// Vue.filter('numThousandth',function(num){
//     return (num.toString().indexOf('.') !== -1) ? num.toLocaleString() : num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
// })
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
